import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

/**
 * A custom useEffect hook that only triggers on updates, not on initial mount
 * @param {Function} effect
 */
function useUpdateEffect(effect, deps = []) {
  const initialMount = useRef(true);

  useEffect(() => {
    if (initialMount.current) {
      initialMount.current = false;
    } else {
      effect();
    }
  }, deps);
}

function useErrorListener(activeError) {
  const [error, setError] = useState(activeError);

  useEffect(() => {
    setError(activeError);
  }, [activeError]);

  useUpdateEffect(() => {
    if (error) {
      toast.error(typeof error === 'string' ? error : JSON.stringify(error), {
        autoClose: true,
      });
    }
  }, [error]);
}

function ErrorListener({ activeError = null }) {
  useErrorListener(activeError.activeError);
  return null;
}

ErrorListener.propTypes = {
  activeError: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
};

const mapStateToProps = state => ({
  activeError: state.error,
});

export default connect(mapStateToProps, null)(ErrorListener);
